import { useState } from "react";
import Footer from "../components/Footer";
import Startbar from "../components/Startbar";
import Topbar from "../components/Topbar";
import TransactionAdd from "../components/TransactionAdd";


const Transaction = () => {
  const [refreshKey, setRefreshKey] = useState(0); // 🔁 trigger for reload
  return (
    <>
      <Topbar />
      <Startbar />
      <div className="page-wrapper">
        <div className="page-content">
          <div className="container-xxl">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-6">
                <div className="card">
                  <div className="card-body">
                    <TransactionAdd
                      onDepartmentAdded={() =>
                        setRefreshKey((prev) => prev + 1)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Transaction;
